import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CHART_INK, PIE_COLORS, formatUsdFull } from './common';

interface DonutChartProps {
  data: Array<{ name: string; value: number }>;
  valueFormatter?: (value: number) => string;
  /** Optional caption in the hole — the total the slices add up to. */
  centerLabel?: string;
  centerValue?: string;
}

/** Share-of-total donut (e.g. profit by source, deposits by provider). */
const DonutChart: React.FC<DonutChartProps> = ({
  data,
  valueFormatter = formatUsdFull,
  centerLabel,
  centerValue,
}) => (
  <div className="relative h-full w-full">
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          isAnimationActive={false}
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius="58%"
          outerRadius="82%"
          paddingAngle={2}
          strokeWidth={1}
        >
          {data.map((entry, index) => (
            <Cell key={entry.name} fill={PIE_COLORS[index % PIE_COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value: number, name: string) => [valueFormatter(value), name]}
          contentStyle={{ borderRadius: 10, border: `1px solid ${CHART_INK.grid}`, fontSize: 12 }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} iconType="circle" iconSize={8} />
      </PieChart>
    </ResponsiveContainer>
    {centerValue && (
      // -translate-y-3 lifts the caption clear of the legend row under the ring.
      <div className="pointer-events-none absolute inset-0 flex -translate-y-3 flex-col items-center justify-center">
        {centerLabel && (
          <span className="text-[10px] uppercase tracking-wide text-muted-foreground">
            {centerLabel}
          </span>
        )}
        <span className="text-base font-semibold tabular-nums text-blue-950">{centerValue}</span>
      </div>
    )}
  </div>
);

export default DonutChart;
